import {Directive, HostListener, Self} from '@angular/core';
import {FormControl, NgModel} from '@angular/forms';
import {isNullOrUndefined} from 'util';


@Directive({
    selector: '[ngModel][ibanControl]'
})
export class IbanControlDirective {

    private control: FormControl;

    constructor(@Self() private model: NgModel) {
        this.control = model.control;
    }

    @HostListener('input', ['$event.target.value'])
    onInput(value) {
        let rawValue = value.replace(/\s/g, '');
        let formattedValue = this.toFormattedValue(rawValue);
        //
        this.model.valueAccessor.writeValue(formattedValue);
        this.model.viewToModelUpdate(rawValue);
        this.control.markAsTouched();
        this.control.setValue(rawValue, {emitModelToViewChange: false});
        this.control.updateValueAndValidity();
    }

    private toFormattedValue(value) {
        return (!isNullOrUndefined(value)) ? value.match(/^$|.{1,4}/g).join(' ') : value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/input/iban-control/iban-control.directive.ts